// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__Gd9g2","active":"Tab_active__xt6+g","activeIndicator":"Tab_activeIndicator__CW-C4"};